<template>
    <div class="home-loading">
        <b-skeleton-img
            no-aspect
            height="250px"
        />

        <div class="home-header border-bottom border-top">
            <b-container>
                <b-row
                    align-v="center"
                    class="py-3"
                >
                    <b-col
                        cols="12"
                        md="3"
                        lg="2"
                    >
                        <b-skeleton
                            type="avatar"
                            width="135px"
                            height="135px"
                        />
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                        lg="7"
                    >
                        <b-skeleton
                            type="text"
                            width="200px"
                            height="40px"
                        />
                        <b-skeleton
                            type="text"
                            width="146px"
                            height="25px"
                        />

                    </b-col>
                    <b-col
                        cols="12"
                        md="3"
                        class="action-btn-col"
                    >
                        <b-skeleton
                            type="button"
                            height="50px"
                            class="w-100"
                        />
                    </b-col>
                </b-row>

            </b-container>
        </div>

        <b-container>
            <b-row class="mt-5 mb-4">
                <b-col>
                    <b-skeleton
                        type="card"
                        height="163px"
                    />
                </b-col>
            </b-row>
        </b-container>
        <b-container class="mb-5">
            <b-row>
                <b-col>
                    <div class="d-none d-lg-flex card-deck">
                        <b-card
                            body-class="text-center"
                            class="agent-contact-info-card"
                        >
                            <b-skeleton-img/>
                            <b-skeleton width="55%" class="mx-auto"/>
                            <b-skeleton width="70%" class="mx-auto"/>
                            <b-skeleton width="55%" class="mx-auto"/>
                            <b-skeleton width="85%" class="mx-auto"/>
                        </b-card>

                        <b-card
                        >
                            <b-skeleton width="55%"/>
                            <b-skeleton width="70%"/>
                            <b-skeleton width="55%"/>
                            <b-skeleton width="85%"/>
                            <br/>
                            <br/>
                            <br/>
                            <b-skeleton width="55%"/>
                            <b-skeleton width="55%"/>
                            <b-skeleton width="55%"/>

                        </b-card>
                    </div>


                    <div class="d-block d-lg-none card-deck">
                        <b-card
                            body-class="text-center"
                            class="agent-contact-info-card-md"
                        >
                            <b-row>
                                <b-col
                                    cols="5"
                                    class="text-center my-auto"
                                >
                                    <b-skeleton-img />
                                    <br />
                                    <b-skeleton width="55%" class="mx-auto" />
                                    <b-skeleton width="70%" class="mx-auto" />
                                    <b-skeleton width="55%" class="mx-auto" />
                                    <b-skeleton width="85%" class="mx-auto" />
                                </b-col>

                                <b-col cols="7">
                                    <b-skeleton width="55%" />
                                    <b-skeleton width="70%" />
                                    <b-skeleton width="55%" />
                                    <b-skeleton width="85%" />
                                    <br />
                                    <br />
                                    <br />
                                    <b-skeleton width="55%" />
                                    <b-skeleton width="55%" />
                                    <b-skeleton width="55%" />
                                </b-col>
                            </b-row>
                        </b-card>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import './HomeLoading.scss';

export default {
    name: "HomeLoading"
};
</script>
